import { Drawer } from "@tvg/fuse/drawer";
import { useFocusTrap } from "client/components/utils/useFocusTrap";
import React from "react";
import { NavTreeDepSplit } from "../../../../services/navigation/types";
import MenuSubDepartmentLink from "../menu-subdepartment-link/MenuSubDepartmentLink";
import styles from "./SlideOutDepartmentMenu.module.css";

const { useRef } = React;

export interface SlideOutDepartmentMenuProps {
  isOpen: boolean;
  backButtonCallback: () => void;
  closeButtonCallback: () => void;
  subDepartments: NavTreeDepSplit[];
  title: string;
  dataTestId?: string;
}

const SlideOutDepartmentMenu: React.FC<SlideOutDepartmentMenuProps> = ({
  backButtonCallback,
  closeButtonCallback,
  isOpen,
  subDepartments,
  title,
  dataTestId,
}) => {
  const deptRef = useRef<HTMLDivElement>(null);

  useFocusTrap({
    isOpen,
    containerRef: deptRef,
    onClose: () => {
      closeButtonCallback();
    },
  });

  return (
    <Drawer
      className={`${styles.slideOutDepartmentMenu} navi-header-fe-slide-out-department navi-header-fe-department-slide-out`}
      title={title}
      backCallback={backButtonCallback}
      closeCallback={closeButtonCallback}
      dataTestId={dataTestId}
      desktopDisplay={false}
      hasBackButton={true}
      open={isOpen}
      ref={deptRef}
      srLabelBackButton="Go back to main menu"
      srLabelCloseButton="Close menu"
      zIndex="101"
    >
      <div
        className={`${styles.slideOutDepartmentMenu__body} slide-out-department__body`}
      >
        {subDepartments
          .filter((subDepartment) => subDepartment.items.length > 0)
          .map((subDepartment) => {
            const subDeptKey = subDepartment.name
              .replace(/[& ]/g, "-")
              .toLowerCase();
            return (
              <div
                key={subDeptKey}
                className={`${styles.slideOutDepartmentMenu__contentWrapper} slide-out-department__content-wrapper`}
              >
                <h3
                  className={`${styles.slideOutDepartmentMenu__departmentHeading} slide-out-menu__department-heading`}
                >
                  {subDepartment.name}
                </h3>
                <ul
                  className={`${styles.slideOutDepartmentMenu__departmentLinks} slide-out-department__department-links-ul`}
                >
                  {subDepartment.items.map((item) => {
                    const linkKey = item.name
                      .replace(/[& ]/g, "-")
                      .toLowerCase();
                    return (
                      <li
                        className={`${styles.slideOutDepartmentMenu__departmentLinkItem} slide-out-department__department-link-item`}
                      >
                        <MenuSubDepartmentLink
                          className={`${styles.slideOutDepartmentMenu__departmentLink} slide-out-department__link`}
                          key={linkKey}
                          href={item.link}
                          spanText={item.name}
                          spanNumber={item.count}
                        />
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
      </div>
    </Drawer>
  );
};

export default SlideOutDepartmentMenu;
